import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { useSelector } from "react-redux";
import { addDesignRate, getDesignRate } from "../../services/ratediary.service";

export default function RateDiaryEdit({ initialData }) {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state?.auth);
  const [designRate, setDesignRate] = useState(null);
  const [isRateEditable, setIsRateEditable] = useState(true);
  const [isLoading2, setIsLoading2] = useState(false);
  const [rateDiaryDesign, setRateDiaryDesign] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const designRateId = queryParams.get("id");
  const backPage = queryParams.get("page");
  const search = queryParams.get("search");

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { ...initialData },
  });

  const handleDesignRateFocus = () => {
    // console.log("editable1");

    if (!isRateEditable && designRate) {
      // console.log("editable");

      Swal.fire({
        title: "Design Rate",
        text: `The current design rate is ₹${designRate}, which was last updated on ${new Date(
          rateDiaryDesign?.design_rate_update_date
        )
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })
          .replace(" ", " ")
          .replace(/(\w+ \w+)/, "$1,")}. Do you want to update it?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Update",
        cancelButtonText: "No, Keep Current",
      }).then((result) => {
        if (result.isConfirmed) {
          setIsRateEditable(true);
        } else {
          setValue("designRate", designRate);
          setIsRateEditable(false);
        }
      });
    }
  };

  const fetchRateDiaryDesign = async () => {
    try {
      const res = await getDesignRate(token, designRateId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res?.data);

        setRateDiaryDesign(res?.data);
        setDesignRate(res.data.design_rate);
        setValue("designRate", res.data.design_rate);
        res?.data?.design_rate
          ? setIsRateEditable(false)
          : setIsRateEditable(true);

        console.log("Rate Diary fetched successfully:", res.data);
      } else {
        setDesignRate(null); // Reset design rate on failure
        setValue("designRate", null);
        Swal.fire(
          "Error",
          "Failed to fetch Ratediary design details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching Ratediary design:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the Ratediary design. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchRateDiaryDesign();
  }, []);

  useEffect(() => {
    // console.log("rate....", rateDiaryDesign);
    if (rateDiaryDesign) {
      setValue("brandname", rateDiaryDesign?.brand_name);
      setValue("productName", rateDiaryDesign?.product_name);
      setValue("designNumber", rateDiaryDesign?.design_number);
      setValue("acronymsmall", rateDiaryDesign?.brand_acronym);
      setValue("designsize", rateDiaryDesign?.size_name);
      setValue("designid", rateDiaryDesign?.design_id);
      setValue("barcodeDate", rateDiaryDesign?.barcode_date || "-");
      setValue("stock", rateDiaryDesign?.stock);
      setValue("designRate", rateDiaryDesign?.design_rate);
      setValue("inStock", rateDiaryDesign.instock ? "True" : "False");
    }
  }, [rateDiaryDesign]);

  const onSubmit = async (item) => {
    console.log("Submitting Rate Diary:", item);

    setIsLoading2(true);

    const data = {
      brand: rateDiaryDesign?.brand,
      product: rateDiaryDesign?.product_id,
      size: rateDiaryDesign?.size_id,
      design_no: item?.designNumber,
      stock: item?.stock,
      design_rate: item?.designRate,
      barcode_date: item?.barcodeDate,
      description: item?.note,
      is_update: true,
    };

    // console.log(data);

    try {
      const res = await addDesignRate(token, data);
      console.log("Rate Diary Response:", res);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: "Rate Diary entry has been updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(
            `/rate-diary/list?page=${backPage}${
              search ? `&search=${search}` : ""
            }`
          );
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error ||
            "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding Rate Diary:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Product Design</h4>
                <Link
                  to={`/rate-diary/list?page=${backPage}${
                    search ? `&search=${search}` : ""
                  }`}
                >
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    {/* Agent Name */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Company (Brand) Name</label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Brand name"
                        {...register("brandname", {
                          required: "brand name is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.brandname && (
                        <p className="error">{errors.brandname.message}</p>
                      )}
                    </div>

                    {/* Product Name */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter product name"
                        {...register("productName", {
                          required: "Product name is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.productName && (
                        <p className="error">{errors.productName.message}</p>
                      )}
                    </div>

                    {/* Design Number */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Design Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Design Number"
                        {...register("designNumber", {
                          required: "Design number is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.designNumber && (
                        <p className="error">{errors.designNumber.message}</p>
                      )}
                    </div>

                    {/* Acronymn */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Acronymn</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Acronymn"
                        {...register("acronymsmall", {
                          required: "Acronymn is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.acronymsmall && (
                        <p className="error">{errors.acronymsmall.message}</p>
                      )}
                    </div>

                    {/* Design size */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Design size</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Design size"
                        {...register("designsize", {
                          required: "Design size is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.designsize && (
                        <p className="error">{errors.designsize.message}</p>
                      )}
                    </div>

                    {/* Design ID */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Design ID</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Design ID"
                        {...register("designid", {
                          required: "Design ID is required",
                        })}
                        style={{
                          backgroundColor: "#f8f9fa",
                        }}
                        disabled
                      />
                      {errors.designid && (
                        <p className="error">{errors.designid.message}</p>
                      )}
                    </div>

                    {/* Barcode date*/}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Barcode Date</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Barcode Date"
                        {...register("barcodeDate", {
                          required: "Barcode Date is required",
                        })}
                      />
                      {errors.barcodeDate && (
                        <p className="error">{errors.barcodeDate.message}</p>
                      )}
                    </div>

                    {/* stock */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Stock</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Stock Quantity"
                        {...register("stock", {
                          required: "Stock is required",
                        })}
                      />
                      {errors.stock && (
                        <p className="error">{errors.stock.message}</p>
                      )}
                    </div>

                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Design Rate</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <div
                        onClick={handleDesignRateFocus}
                        style={{
                          cursor: isRateEditable ? "auto" : "pointer", // Only allow click if editable
                        }}
                      >
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter design rate"
                          {...register("designRate", {
                            required: "Design rate is required",
                          })}
                          disabled={!isRateEditable} // Disable input if not editable
                          style={{
                            backgroundColor: !isRateEditable
                              ? "#f8f9fa"
                              : "white",
                            pointerEvents: isRateEditable ? "auto" : "none", // Allow input when editable
                          }}
                        />
                      </div>
                      {errors.designRate && (
                        <p className="error">{errors.designRate.message}</p>
                      )}
                    </div>

                    {/* Description */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Note</label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Write a note"
                        {...register("note")}
                        value={watch("note")}
                      />
                    </div>

                    {/* History */}
                    {rateDiaryDesign &&
                    rateDiaryDesign?.description?.length > 0 ? (
                      <div className="mb-4 col-md-6">
                        <label className="form-label fw-bold">Notes</label>
                        <div>
                          <table style={{ borderCollapse: "collapse" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "none" }}></th>
                                <th style={{ border: "none" }}></th>
                                <th style={{ border: "none" }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {rateDiaryDesign?.description?.map((item, i) => (
                                <tr key={i}>
                                  <td style={{ border: "none" }}>
                                    {new Date(item.date)
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                      })
                                      .replace(" ", " ")
                                      .replace(/(\w+ \w+)/, "$1,")}
                                  </td>
                                  <td className="px-3 py-2">:</td>
                                  <td style={{ border: "none" }}>
                                    {item.content}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {/* Update Button */}

                  {!isLoading2 ? (
                    <div className="col-sm-4">
                      <button type="submit" className="btn btn-primary w-100">
                        UPDATE PRODUCT DESIGN
                      </button>
                    </div>
                  ) : (
                    <div className="col-sm-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        disabled
                      >
                        UPDATING PRODUCT DESIGN
                      </button>

                      <div
                        className="spinner-border2 text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
